import React from "react";

const WhatAreKeyTermsDefined = (props: any) => {
    return (
        <div>
            <p>
                <strong>Child/Dependent</strong> - at TransUnion a child/dependent is defined as someone under 18. This distinction is important because TransUnion
                Child Credit Activity Monitoring permits a parent/guardian to monitor their under 18-year-old's credit activity. When a child turns 18, they are
                considered an adult and can monitor their own credit.
            </p>
            <p>
                <strong>Minor</strong> - a TransUnion a minor is defined as someone under 16. This distinction is important because for this age, a parent/guardian
                would use a Protected Consumer Freeze to freeze their child's/dependent's credit file.
            </p>
            <p>
                <strong>Protected Consumer Freeze</strong> - a type of freeze where a parent/guardian can protect their under 16-year-old child's credit by freezing
                their TransUnion credit file.
            </p>
            <p>
                <strong>Freeze</strong> - a type of freeze where a 16-or-17-year old can protect their own credit by freezing their TransUnion credit file.
            </p>
        </div>
    );
};

export default WhatAreKeyTermsDefined;
